<template>
  <b-row>
    <b-col>
      <b-table
        ref="table"
        :items="tableData.transcriptions"
        :fields="fields"
        responsive
        :sticky-header="true"
        class="border-default border-b border-r border-l rounded custom-table"
        @head-clicked="onRowClicked"
      >
        <template #cell(fileName)="data">
          <a
            v-clipboard:copy="returnCompletePath(data.item.fileName)"
            v-clipboard:success="copySuccess"
            class="text-primary text-break"
          >
            {{ returnCompletePath(data.item.fileName) }}
            <GjIcon
              name="Copy"
              size="20"
            />
          </a>
        </template>
      </b-table>
    </b-col>
  </b-row>
</template>

<script>

export default {
  name: 'JobTranscriptions',
  props: {
    tableData: {
      type: Object,
      default: () => {},
    },
    endpoint: {
      type: String,
      default: null,
    },
    destination: {
      type: String,
      default: null,
    },
    group: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      fields: [
        { key: 'type', label: 'Type' },
        { key: 'fileName', label: 'File Name' },
      ],
    }
  },
  methods: {
    returnCompletePath(extension) {
      return `${this.endpoint}${this.destination}/transcriptions/${extension}`
    },
    onRowClicked() {
      this.$emit('closeTable')
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-table {
  ::v-deep {
    table{
      thead{
        cursor: pointer !important;
      }
    }
  }
}
</style>
